// UnassignedTabs.tsx
import { useState, useEffect } from "react";
import { Tabs, Tab } from "@mui/material";
import UnassignedTickets from "./UnassignedTickets";
import { activitySubTabsSx } from "./activityTabsSx";

const UnassignedTabs = () => {
  const [tabIndex, setTabIndex] = useState(() => {
    const savedTabIndex = sessionStorage.getItem("unassignedTabIndex");
    return savedTabIndex ? Number(savedTabIndex) : 0;
  });

  useEffect(() => {
    sessionStorage.setItem("unassignedTabIndex", tabIndex.toString());
  }, [tabIndex]);

  const taskSource = tabIndex === 0 ? "ticket" : "email";

  return (
    <>
      <Tabs
        value={tabIndex}
        onChange={(_, val) => setTabIndex(val)}
        sx={activitySubTabsSx}
      >
        <Tab label="Tickets" />
        <Tab label="Emails" />
      </Tabs>

      <div className="pt-3 px-3 pb-0">
        <UnassignedTickets task_source={taskSource} />
      </div>
    </>
  );
};

export default UnassignedTabs;